import React, { useEffect, useState } from 'react';
import {useSelector, useDispatch} from 'react-redux';
import EditAvistamento from './EditAvistamento';
import EditAninhamento from './EditAninhamento';
import EditAtaque from './EditAtaque';
import {useHistory, useLocation} from 'react-router';
import './EditModal.css';
import { validate_observation, delete_observation_confirm} from '../redux/actions';

function EditModal(props){
    const validatingState = useSelector(state => state.editObservation.validatingObservationStatus);
    const editingObs = useSelector(state => state.editObservation.editingObservation);
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const [observation, setObservation] = useState(null)

    const observation_redux = useSelector(
        (state) => state.validate.avistamentos,
      )

    useEffect(() => {
        
        
        if(observation_redux.length>0){
          
            const observation_val = observation_redux.filter((obs) => obs._id === editingObs.id)[0];
       
            const observation_set = {...observation_val,
                properties:{...observation_val.properties,
                    data: new Date(observation_val.properties.data)
                }
            }
              setObservation(observation_set)
        }
        

    }, [observation_redux])

      const handleChange = (e) =>{
        let edited_observation
        if(e.target.name==='alvo'){
    
            edited_observation = {...observation,
                properties: {...observation.properties, alvo:{
                    ...observation.properties.alvo, [e.target.value]: !observation.properties.alvo[e.target.value]
                }
            }
            }
        }else{
            edited_observation = {...observation,
                properties: {...observation.properties, [e.target.name]: e.target.value}
            }
        }
        
        setObservation(edited_observation)
    }

    const handleDeleteRequest = () => {
        dispatch(delete_observation_confirm(editingObs.id, editingObs.tipo))
        const current = location.pathname
        history.push(`${current}/confirmar`)
    }
     return(
         <div className='editing-modal'>
            {validatingState==='CHECKING' && observation!==null?
                <>
                    <div className='editing-imagem'><img src={`imagens/${observation.properties.imagens[0].url}`} style={{width:'100%', height:'100%', objectFit:'contain'}}/></div>
                    
                    <div className='scrollbar-custom' id='editing-form'>
                        <div style={{flexDirection: 'row'}}>
                            <span style={{fontWeight:'bold'}}>Data do avistamento: </span>
                            <span>{observation.properties.data.toLocaleDateString("pt-PT")}</span>
                        </div>
                        <div style={{flexDirection: 'row'}}>
                            <span style={{fontWeight:'bold'}}>Hora do avistamento: </span>
                            <span>{observation.properties.data.toLocaleTimeString("pt-PT", {hour:'2-digit', minute:'2-digit'})}</span>
                        </div>
                        <div style={{flexDirection: 'row'}}>
                            <span style={{fontWeight:'bold'}}>Concelho: </span>
                            <span>{observation.properties.concelho}</span>
                        </div>
                        <div style={{flexDirection: 'row'}}>
                            <span style={{fontWeight:'bold'}}>Utilizador: </span>
                            <span>{observation.properties.id_user.username}</span>
                        </div>
                        {editingObs.tipo === 'avistamento'  && editingObs.id ? (
                            <EditAvistamento observation={observation} handleChange={handleChange}/>
                        ): null}
                        {editingObs.tipo === 'aninhamento'  && editingObs.id ? (
                            <EditAninhamento observation={observation} handleChange={handleChange}/>
                        ): null}
                        {editingObs.tipo === 'ataque'  && editingObs.id ? (
                            <EditAtaque observation={observation} handleChange={handleChange}/>
                        ): null}
                    </div>
                    <div className='editing-buttons'>
                        <div onClick={handleDeleteRequest} style={{color:'red', cursor: 'pointer'}}>Eliminar</div>
                        <div onClick={() => dispatch(validate_observation(observation, editingObs.tipo))} style={{color:'green', cursor: 'pointer'}}>Validar</div>
                        
                    </div>
                    <div className='editing-cancel' onClick={() => history.goBack()} >Cancelar</div>
                    
                </>:null}
            {validatingState==='VALIDATING' ? <div>A validar...</div>:null}
            {validatingState==='VALIDATED' ? <div>Observação validada</div>:null}
            {validatingState==='FAILED' ? <div>Ocorreu um erro. Por favor tente novamente.</div>:null}
        </div>
    )
}

export default EditModal


